'use strict';

import type { UserCallLogSummary } from '../../Entities/User/UserCallLogSummary';
import { EntityCollection } from '../EntityCollection';

export class UserCallLogSummaryCollection extends EntityCollection<UserCallLogSummary> {}
